import React from 'react';

import { Text, Box } from '@origin-digital/style-guide';

const CurrentStep: React.StatelessComponent<CurrentStepProps> = ({ ...props }: CurrentStepProps) => {
  const { isSuccessPage, step, stepCount } = props;
  if (isSuccessPage) {
    return null;
  }

  return (
    <Box marginBottom={8}>
      <Text>
        Step {step + 1} of {stepCount}
      </Text>
    </Box>
  );
};

export { CurrentStep as default };
